import { render, staticRenderFns } from "./login_New.vue?vue&type=template&id=590d63ee&scoped=true&"
import script from "./login_New.vue?vue&type=script&lang=js&"
export * from "./login_New.vue?vue&type=script&lang=js&"
import style0 from "./login_New.vue?vue&type=style&index=0&id=590d63ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d63ee",
  null
  
)

export default component.exports